import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectedItem'
})
export class SelectedItemPipe implements PipeTransform {

  transform(data: string): string {
    if (data != null) {
      return data
    }
    else {
      return 'na'
    }
  }

}
